/**
 * Phase 4 — Payments (G.19). Preset amounts Lloyd supplied (Jul 6).
 * Values are in whole US dollars; the API takes cents.
 */
export const INITIAL_CASE_PRESETS_USD = [375, 475, 600, 1000, 1750, 2500];

export const SUBSEQUENT_BILLING_PRESETS_USD = [
  250, 500, 1200, 1500, 2200, 2500, 3200, 3500,
];

export const formatUsd = (dollars: number): string =>
  dollars.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 });

export const formatCentsUsd = (cents: number): string =>
  (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
